import { Avatar, Box, HStack, Stack, Text } from "@chakra-ui/react";
import { KYDOrganizationCompact } from "@common/interfaces/KYDOrganization";
import { KYDOrganizationUser } from "@common/interfaces/KYDUser";
import { useEffect, useState } from "react";

interface UserProfileProps {
  currentUser: KYDOrganizationUser;
  onOrganizationClick: () => void;
}

export const UserProfile = (props: UserProfileProps) => {
  const { currentUser, onOrganizationClick } = props;
  const [currentOrganization, setCurrentOrganization] =
    useState<KYDOrganizationCompact>();

  useEffect(() => {
    if (currentUser) {
      const _currentOrganization = currentUser.organizations.find(
        (org) => org.id === currentUser.organization_id
      );

      setCurrentOrganization(_currentOrganization);
    }
  }, [currentUser]);

  return (
    <Stack spacing="3">
      {currentOrganization ? (
        <HStack
          px={4}
          py={2}
          borderWidth={"1px"}
          borderColor={"gray.200"}
          rounded={"lg"}
          cursor={"pointer"}
          onClick={onOrganizationClick}
        >
          <Avatar
            src={currentOrganization.logo_url}
            name={currentOrganization.name}
            size="sm"
          />
          <Text fontWeight={"bold"}>{currentOrganization.name}</Text>
        </HStack>
      ) : null}
      <Box>
        <Text fontWeight="medium" fontSize="sm">
          {`${currentUser.first_name} ${currentUser.last_name}`}
        </Text>
        <Text color="muted" fontSize="sm">
          {currentUser.email}
        </Text>
      </Box>
    </Stack>
  );
};
